var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('o-confirmation-view',{attrs:{"image":"images/delijn-header.jpg","message":"Je bestelling is met succes geregistreerd. Je ticket zal beschikbaar zijn in je ticketportefeuille van zodra de verwerking klaar is.","nav-bar-title":"De Lijn"}})}
var staticRenderFns = []

export { render, staticRenderFns }